module.exports = __webpack_public_path__ + "static/img/Jack_Billings_desktop.19fc1fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jack_Billings_desktop.jpg
// module id = iXwT
// module chunks = 0